import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { EMARResidentScreen } from './EMARResidentScreen'
import EMARResidentScreenV2 from '../ResidentEmarV2Screens/EMARResidentScreenV2/EMARResidentScreenV2'

const EMARResidentMARChartScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_chart'] })?.data

  const emarV2ChartEnabled = flags?.emar_v2_chart?.enabled ?? false

  if (emarV2ChartEnabled) {
    return <EMARResidentScreenV2 />
  }

  return <EMARResidentScreen />
}

export default EMARResidentMARChartScreenWrapper
